import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const testimonials = [
  {
    quote: "I needed a hassle free MVP for a mobile app. Kallisto released first version in 2 weeks!",
    name: "Johny",
    title: "CEO of Lightening",
  },
  {
    quote: "Kallisto is a great team of professionals. They helped us to create our international marketplace and that was executed fast and clean.",
    name: "Artem",
    title: "CEO of Floroteka.ua",
  },
  {
    quote: "Kallisto team help was great during the research, analysis and planning phase. Clean roadmap with all tickets and priority in place in a week.",
    name: "Ben",
    title: "General Manager of SportsMate",
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const next = () => setCurrent((current + 1) % testimonials.length);
  const prev = () => setCurrent((current - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="lovable-card p-12">
          <h2 className="text-4xl font-bold mb-12 text-white text-center">Testimonials</h2>

          <div className="bg-gray-900/50 px-16 py-10 rounded-2xl shadow-md transition relative">
            <p className="text-xl md:text-2xl leading-relaxed mb-6 text-white/90">
              "{testimonials[current].quote}"
            </p>
            <div>
              <p className="text-green-400 font-semibold">{testimonials[current].name}</p>
              <p className="text-white/60 text-sm">{testimonials[current].title}</p>
            </div>

            {/* Arrows */}
            <button
              onClick={prev}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-400 hover:text-green-300 transition-colors"
            >
              <ChevronLeft size={32} />
            </button>
            <button
              onClick={next}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-green-400 hover:text-green-300 transition-colors"
            >
              <ChevronRight size={32} />
            </button>
          </div>

          {/* Dots */}
          <div className="mt-8 flex justify-center gap-2">
            {testimonials.map((_, index) => (
              <div
                key={index}
                className={`w-3 h-3 rounded-full transition ${
                  index === current ? 'bg-green-400' : 'bg-white/40'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
